import mapBasic from "./map-basic"
// import mapTool from "./map-tool"

const components = {
  mapBasic,
  // mapTool,
}
const install = function (Vue) {
  if (install.installed) return
  components.map((component) => Vue.component(component.name, component))
}
// 判断是否是直接引入文件（通过script导入），如果是，就不用调用Vue.use()
if (typeof window !== "undefined" && window.Vue) {
  install(window.Vue)
}
const API = {
  install,
}
export default API
